'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import normalStar from 'assets/img/account/normalStar@2x.png';

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

var _exuWhite2x = require('assets/img/account/exuWhite@2x.png');

var _exuWhite2x2 = _interopRequireDefault(_exuWhite2x);

var _address2x = require('assets/img/account/address@2x.png');

var _address2x2 = _interopRequireDefault(_address2x);

var _Constant = require('helpers/Constant');

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _expiredVoucherImage = require('assets/img/voucher/expiredVoucherImage.jpg');

var _expiredVoucherImage2 = _interopRequireDefault(_expiredVoucherImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(RewardItem, _Component);

  function RewardItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RewardItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RewardItem.__proto__ || (0, _getPrototypeOf2.default)(RewardItem)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = _defaultVoucherImage2.default;
    }, _this.handlePress = function (e) {
      var _this$props = _this.props,
          onPress = _this$props.onPress,
          tracking = _this$props.tracking,
          manualTrack = _this$props.manualTrack,
          item = _this$props.item;

      if (onPress) onPress(e);
      if (tracking && manualTrack) {
        manualTrack((0, _extends3.default)({}, tracking, {
          button: 'Detail Voucher',
          packageServiceId: item.packId,
          label: item.name
        }));
      }
    }, _this.handleExchange = function (e) {
      var _this$props2 = _this.props,
          onExchange = _this$props2.onExchange,
          tracking = _this$props2.tracking,
          manualTrack = _this$props2.manualTrack,
          item = _this$props2.item;

      if (onExchange) onExchange(e);
      if (tracking && manualTrack) {
        manualTrack((0, _extends3.default)({}, tracking, {
          button: 'Get Voucher',
          packageServiceId: item.packId,
          label: item.name
        }));
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RewardItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          style = _props.style,
          imgStyle = _props.imgStyle,
          redeemBtnText = _props.redeemBtnText;
      var title = item.title,
          image = item.image,
          shopName = item.shopName,
          service = item.service,
          address = item.address,
          newPrice = item.newPrice,
          oldPrice = item.oldPrice,
          exu = item.exu;

      if (!service) return null;
      var styles = require('./RewardItemV2.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.item + ' ' + style, onClick: this.handlePress },
        _react2.default.createElement(
          _reactLazyload2.default,
          { height: 116 },
          _react2.default.createElement('img', {
            src: image,
            className: styles.rewardImage + ' ' + imgStyle,
            onError: this.onErrorImage
          })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.contentView },
          !!service.name && _react2.default.createElement(
            'div',
            { className: styles.serviceName },
            service.name,
            ' hihi'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            title
          ),
          _react2.default.createElement(
            'div',
            { className: styles.shopView },
            _react2.default.createElement('img', { src: _Images2.default.voucher.iconHome, className: styles.homeIcon }),
            _react2.default.createElement(
              'div',
              { className: styles.shopName },
              shopName
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.address },
            address
          ),
          _react2.default.createElement(
            'div',
            { className: styles.priceView },
            _react2.default.createElement(
              'div',
              {
                className: styles.newPrice,
                style: newPrice > 1000000 ? { fontSize: 12 } : null
              },
              _support.Helper.formatMoney(newPrice)
            ),
            _react2.default.createElement(
              'div',
              { className: styles.oldPrice },
              _support.Helper.formatMoney(oldPrice)
            ),
            _react2.default.createElement('div', { style: { flex: 1 } }),
            _react2.default.createElement(
              'div',
              { className: styles.btn, onClick: this.handleExchange },
              _react2.default.createElement(
                'div',
                { className: styles.btnText },
                redeemBtnText ? redeemBtnText : 'L\u1EA5y voucher'
              ),
              exu ? _react2.default.createElement('img', { src: _exuWhite2x2.default, className: styles.exu }) : null
            )
          )
        )
      );
    }
  }]);
  return RewardItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  redeemBtnText: _react.PropTypes.string,
  style: _react.PropTypes.string,
  imgStyle: _react.PropTypes.string,
  tracking: _react.PropTypes.object,
  onPress: _react.PropTypes.func,
  onExchange: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2);
exports.default = RewardItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/RewardItemV2.js
// module id = 1632
// module chunks = 0